import {Component, Inject, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {CommonService} from '../../services/common.service';
import {TranslateService} from '@ngx-translate/core';
import {DOCUMENT} from '@angular/common';
import {AuthService} from '../../auth/auth.service';
import {User} from '../../models/user';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  public code: string;
  public password: string;
  public user: User;

  constructor(private router: Router,
              private commonService: CommonService,
              private translate: TranslateService,
              private authService: AuthService,
              @Inject(DOCUMENT) private document: any) {
  }

  ngOnInit(): void {
    this.authService.isAuthenticated().then(isAuth => {
      if (!isAuth) {
        this.authService.login();
      } else {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.router.navigate(['dashboard']);
      }
    });
  }

  public onSubmit(searchByCode: NgForm): void {
  }

  public hoverImageButton(imageButton: any): void {
    imageButton.setAttribute('src', 'assets/images/buttons/switchLangHover.png');
  }

  public unHoverImageButton(imageButton: any): void {
    imageButton.setAttribute('src', 'assets/images/buttons/switchLang.png');
  }

  public changeLanguage(): void {
    this.translate.use(this.translate.currentLang === 'sk' ? 'en' : 'sk');
    localStorage.setItem('lang', this.translate.currentLang);
  }

  public logout(): void {
    this.authService.logout();
  }
}
